import api from './api';
import {
  Vendor,
  CreateVendorRequest,
  UpdateVendorRequest,
  VendorQueryParams,
  VendorResponse,
  VendorSummary,
  VendorPurchaseSummary,
} from '../types/vendor.types';

export const vendorService = {
  // One page of vendors, searched and filtered on the server
  getVendors: async (query: VendorQueryParams): Promise<VendorResponse> => {
    const params = {
      page: query.page,
      limit: query.limit,
      ...(query.search ? { search: query.search } : {}),
      ...(query.state ? { state: query.state } : {}),
      ...(query.isActive !== undefined ? { isActive: query.isActive } : {}),
      ...(query.sortBy ? { sortBy: query.sortBy } : {}),
      ...(query.sortOrder ? { sortOrder: query.sortOrder } : {}),
    };
    const response = await api.get<VendorResponse>('/vendors', { params });
    return response.data;
  },

  getSummary: async (): Promise<VendorSummary> => {
    const response = await api.get<VendorSummary>('/vendors/summary');
    return response.data;
  },

  // What has been bought from one vendor, with its latest purchase orders
  getPurchaseSummary: async (id: string): Promise<VendorPurchaseSummary> => {
    const response = await api.get<VendorPurchaseSummary>(`/vendors/${id}/purchase-summary`);
    return response.data;
  },

  // Get vendor by ID
  getVendorById: async (id: string): Promise<Vendor> => {
    const response = await api.get(`/vendors/${id}`);
    return response.data;
  },

  // Create new vendor
  createVendor: async (vendorData: CreateVendorRequest): Promise<Vendor> => {
    const response = await api.post('/vendors', vendorData);
    return response.data;
  },

  // Update vendor
  updateVendor: async (id: string, vendorData: UpdateVendorRequest): Promise<Vendor> => {
    const response = await api.patch(`/vendors/${id}`, vendorData);
    return response.data;
  },

  // Delete vendor
  deleteVendor: async (id: string): Promise<void> => {
    await api.delete(`/vendors/${id}`);
  },

  // Get active vendors only (for dropdowns)
  getActiveVendors: async (): Promise<Vendor[]> => {
    const response = await api.get('/vendors/active');
    return response.data;
  },
};
